module.exports = __webpack_public_path__ + "static/media/8200.d71bc70a.jpg";